import DateSelectView from "./components/DateSelectView";
import { SVGAsset } from "res";
import { useState, useEffect } from "react";
import { BCMSDate, BCMSValidate } from "bcms-react";
/**
 * @function DateSelect 
 * @param {BCMSDate} value - an instance of BCMSDate
 * @param {FUNCTION} onChange - (STRING -> VOID) function is called when date is selected.
  * @param {BOOL} enableFuture - if future days should be selectable default true
 * @param {BOOL} enablePast - if past days should be selectable default false
 * @param {FUNCTION} disableDay -(BCMSDATE->BOOL) function to check  to disable individual days
 * @returns {React.Component}
 * @example
 * 
 *    let [dateValue,setDate] = useState(BCMSDate.init())
 *     let onChange =(date)=>{
 *        console.log(dateValue)
 *        setDate(()=>date)
 *     }
  ...           
        <DateSelect value={""} onChange={onChange} enablePast={true} enableFuture={false}/>         
 */


export default function DateSelect(props) {

  /* creates a new state for the date select  */
  const dataPoint = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
  let [calendarDate, setCalendar] = useState((props.value === undefined || props.value === "") ? BCMSDate.init() : props.value)
  let [inputDate, setInput] = useState(props.value ? props.value.format("m/d/Y") : "");
  let enablePast =  props.enablePast ?? false;
  let enableFuture = props.enableFuture ?? true;
  let disableDay = props.disableDay ? props.disableDay:  () => { return false; }; 
  // Update the input state if the props.value has been updated
  useEffect(() => setInput(props.value ? props.value.format("m/d/Y") : ""), [ props.value ]);
  const calendarIconDataPoint = props.dataPoint ? { "data-point": `${ props.dataPoint }_Calendar_Icon` } : {};

  let changeDate = (value) => {
    if (props.onChange !== undefined) {
      props.onChange(value)
    }
    setInput(value.format("m/d/Y"));
    setCalendar(BCMSDate.init(value))
  }

  let use = (controllers) => {
    const showValue = (evt) => {
      /* if string from input is a valid date sets in as state for the date select     */
      /*open the date select*/     
      controllers.toggle();
    }

    let dateSelect = (event) => {
      if (BCMSValidate.isDate(event.target.value)) {
        setCalendar(BCMSDate.init(new Date(event.target.value)));
        setInput(event.target.value);
      }
      else {
        setInput(event.target.value);
      }
    }
    return (
      <div className="date-label">
        <div className="input-container">
          <input className="flex-width" value={inputDate} onChange={dateSelect} placeholder="MM/DD/YYYY" data-point={dataPoint}/>
          {/* <label className="floating-label form-row-label">{props.dateLabel}</label> */}
         <span onClick={showValue}> <SVGAsset id="CalendarIcon" className='icon calendar-icon clickable' { ...calendarIconDataPoint } /></span>
        </div>
        <span className="form-row-info-text gray-text">
          {props.children}
        </span>
      </div>
    )
  }
  return <DateSelectView active={ props.active } setDate={calendarDate} inputDate={inputDate} onChange={changeDate} use={use} enablePast={enablePast} enableFuture={enableFuture} disableDay={disableDay}/>
}
